import getTranslation from '@/i18n/getTranslation'
export default {
  methods: {
    outMsg(type, errMsg, errObj) {
      if (errObj && errObj.message) {
        this.$jcmessage({
          message: errObj.message,
          type: type
        })
      } else {
        this.$jcmessage({
          message: errMsg,
          type: type,
          duration: 3000
        })
      }
    },
    confirm(title, context) {
      this.$jcconfirm(context, title, {
        confirmButtonText: getTranslation('确　定')
        // cancelButtonText: '取消'
      })
    }
  }
}
